import { render, staticRenderFns } from "./accountsDetail.vue?vue&type=template&id=41914852&scoped=true&"
import script from "./accountsDetail.vue?vue&type=script&lang=js&"
export * from "./accountsDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountsDetail.vue?vue&type=style&index=0&id=41914852&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41914852",
  null
  
)

export default component.exports